import {
  Button,
  Grid,
  Group,
  Heading,
  Paragraph,
  Skeleton,
} from '@ingeniorforeningen/figurine-core';
import { stripText } from '../../helpers/textsHelpers';
import { ROUTE } from '../../App';
import { AppLanguage } from '../../types';
import './PrintStyling.css';

type PageHeadProps = {
  loading: boolean;
  categoryName?: string;
  caseNumber?: string;
  description?: string;
  myCases?: string;
  language: string;
};

export const PageHead = ({
  loading,
  categoryName,
  caseNumber,
  description,
  myCases,
  language,
}: PageHeadProps) => {
  if (loading || !caseNumber || !description || !myCases) {
    return (
      <Group direction="column" style={{ flex: 1 }}>
        <Skeleton width="25%" height="3.5rem" />
        <Grid container columns={4}>
          <Grid item xs={4} md={3}>
            <Skeleton width="65%" height="2.5em" />
          </Grid>
          <Grid item xs={4} md={1} alignItems="center" justifyItems="flex-end">
            <Skeleton width="100%" height="3.25em" style={{ borderRadius: 32 }} />
          </Grid>
        </Grid>
      </Group>
    );
  }

  const heading = categoryName
    ? stripText(categoryName)
    : language === AppLanguage.Danish
    ? 'Sagsdetaljer'
    : 'Case details';

  return (
    <Group direction="column" style={{ flex: 1 }}>
      <Heading text={stripText(heading)} type="h1" id="case-title" />
      <Grid container columns={4} className="hidden-in-print">
        <Grid item xs={4} md={3}>
          <Paragraph text={stripText(description)} mt="sm" />
        </Grid>
        <Grid
          item
          xs={4}
          md={1}
          alignItems="center"
          justifyItems="flex-end"
          className="hidden-in-print"
        >
          <Button
            text={stripText(myCases)}
            href={language === AppLanguage.English ? ROUTE.HOME.ENGLISH : ROUTE.HOME.DANISH}
          />
        </Grid>
      </Grid>
    </Group>
  );
};
